/**
 * @generated SignedSource<<4e5e012962130e4862e8c098cffb2f11>>
 * @relayHash 5ca0895b358b50aa61a179f1d0119dec
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 78cee41998cc3d2b73d496dd6fcef832a7e943e7cf5bfe2324e0fa97fc4db942

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ClassificationLevelSource = "AUTO" | "CONTENT" | "NONE" | "ORGANIZATION" | "SPACE" | "%future added value";
export type ConfluenceShareableLinkAccessType = "EXTERNAL" | "INTERNAL_LICENSED" | "%future added value";
export type ContentStateRestrictionLevel = "NONE" | "PAGE_OWNER" | "%future added value";
export type DataSecurityPolicyAction = "AI_ACCESS" | "ANONYMOUS_ACCESS" | "APP_ACCESS" | "APP_ACCESS_CONFIGURED" | "ATTACHMENT_DOWNLOAD" | "MCP_ACCESS" | "PAGE_EXPORT" | "PUBLIC_LINKS" | "%future added value";
export type KnowledgeDiscoveryKeyPhraseCategory = "ACRONYM" | "AUTO" | "OTHER" | "PROJECT" | "TEAM" | "%future added value";
export type PublicLinkPageStatus = "BLOCKED_BY_CLASSIFICATION_LEVEL" | "BLOCKED_BY_CONTAINER_POLICY" | "BLOCKED_BY_ORG" | "BLOCKED_BY_ORG_DEFAULT_POLICY" | "BLOCKED_BY_PRODUCT" | "BLOCKED_BY_SPACE" | "OFF" | "ON" | "SITE_BLOCKED" | "SITE_DISABLED" | "SPACE_BLOCKED" | "SPACE_DISABLED" | "TRASHED" | "%future added value";
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type ContentUnifiedQuery$variables = {
  agentSessionsPropertyKey?: string | null;
  autohighlightsEntityAri?: string | null;
  autohighlightsWorkspaceId?: string | null;
  bylineContributorsLimit?: number | null;
  contentId: string;
  fetchAgentSessionsMarker?: boolean | null;
  includeAgentTrustReceiptData?: boolean | null;
  includeAnalyticsByline?: boolean | null;
  includeAudioContent?: boolean | null;
  includeAutohighlights?: boolean | null;
  includeAutomationDiscoveries?: boolean | null;
  includeBylineContributors?: boolean | null;
  includeClassification?: boolean | null;
  includeContentHeader?: boolean | null;
  includeContentHeaderAccess?: boolean | null;
  includeContentHeaderPublicLink?: boolean | null;
  includeFabricEditorEligibility?: boolean | null;
  includeReactions?: boolean | null;
  includeRendererAssetsCustomChrome?: boolean | null;
  includeRendererAssetsDsp?: boolean | null;
  includeRendererAssetsMedia?: boolean | null;
  includeRestrictionAncestors?: boolean | null;
  includeRestrictions?: boolean | null;
  isSSR?: boolean | null;
  preloadLabels?: boolean | null;
  rendererAssetsDspAction?: DataSecurityPolicyAction | null;
  spaceKey?: string | null;
  useContentModeFragment?: boolean | null;
  useNewContentTopper?: boolean | null;
  versionOverride?: number | null;
};
export type ContentUnifiedQuery$data = {
  readonly analyticsBylineFragment?: {
    readonly " $fragmentSpreads": FragmentRefs<"AnalyticsByLine_query">;
  } | null;
  readonly autohighlightsQueryFragment?: {
    readonly " $fragmentSpreads": FragmentRefs<"preloadAutohighlightsQuery_query">;
  } | null;
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly agentSessionsMarker?: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly appearancePublished: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly archivedPageBannerStatusFragment: {
        readonly " $fragmentSpreads": FragmentRefs<"ArchivedPageBannerV2Status_content">;
      };
      readonly audioContent?: {
        readonly audioProperties: {
          readonly nodes: ReadonlyArray<{
            readonly key: string | null;
            readonly value: string | null;
          } | null> | null;
        } | null;
        readonly emoji: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly value: string | null;
          } | null> | null;
        } | null;
        readonly history: {
          readonly createdBy: {
            readonly displayName: string | null;
            readonly profilePicture: {
              readonly path: string;
            } | null;
          } | null;
          readonly ownedBy: {
            readonly displayName: string | null;
            readonly profilePicture: {
              readonly path: string;
            } | null;
          } | null;
        } | null;
        readonly id: string | null;
        readonly links: {
          readonly base: string | null;
          readonly webui: string | null;
        } | null;
        readonly subType: string | null;
        readonly title: string | null;
      } | null;
      readonly audioContentFragment?: {
        readonly " $fragmentSpreads": FragmentRefs<"AudioContentFragment_content">;
      } | null;
      readonly body: {
        readonly dynamic: {
          readonly content: {
            readonly id: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null;
          readonly representation: string | null;
          readonly value: string | null;
          readonly webresource: {
            readonly superbatch: {
              readonly tags: {
                readonly css: string | null;
                readonly js: string | null;
              } | null;
            } | null;
            readonly tags: {
              readonly css: string | null;
              readonly js: string | null;
            } | null;
          } | null;
        } | null;
      } | null;
      readonly bylineClassificationFragment?: {
        readonly " $fragmentSpreads": FragmentRefs<"BylineClassification_content">;
      } | null;
      readonly commentsPanelPermission: {
        readonly " $fragmentSpreads": FragmentRefs<"ViewPageCommentsPanelPermission_content">;
      };
      readonly contentClassification?: {
        readonly classificationLevelDetails: {
          readonly canManageSpaceSettings: boolean;
          readonly classificationControlSetting: string | null;
          readonly classificationLevel: {
            readonly color: string | null;
            readonly description: string | null;
            readonly guideline: string | null;
            readonly guidelineADF: string | null;
            readonly id: string;
            readonly name: string;
            readonly status: string;
          } | null;
          readonly featureEnabled: boolean;
          readonly isReclassificationPermitted: boolean;
          readonly source: ClassificationLevelSource | null;
          readonly userOverrideSetting: string | null;
        } | null;
        readonly id: string | null;
      } | null;
      readonly contentClassificationFragment?: {
        readonly " $fragmentSpreads": FragmentRefs<"useContentClassification_content">;
      } | null;
      readonly contentHeaderFragment?: {
        readonly " $fragmentSpreads": FragmentRefs<"ContentHeader_content">;
      } | null;
      readonly contentProperties: {
        readonly draft: {
          readonly contentMode: string | null;
        } | null;
        readonly latest: {
          readonly contentMode: string | null;
          readonly generatedBy?: string | null;
        } | null;
      } | null;
      readonly contentState: {
        readonly color: string;
        readonly id: string | null;
        readonly name: string;
        readonly restrictionLevel: ContentStateRestrictionLevel;
      } | null;
      readonly contentStateLastUpdated: {
        readonly value: string;
      } | null;
      readonly contentTitleWithByLine?: {
        readonly " $fragmentSpreads": FragmentRefs<"ContentTitleWithByLine_content">;
      } | null;
      readonly coverPicture?: {
        readonly coverPictureProperties: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null> | null;
        } | null;
        readonly id: string | null;
      } | null;
      readonly draftVersion: {
        readonly by: {
          readonly displayName: string | null;
        } | null;
        readonly contentTypeModified: boolean | null;
        readonly friendlyWhen: string | null;
        readonly number: number | null;
        readonly when: string | null;
      } | null;
      readonly history?: {
        readonly createdBy: {
          readonly displayName: string | null;
        } | null;
        readonly createdDate: string | null;
      } | null;
      readonly id: string | null;
      readonly labels?: {
        readonly count: number | null;
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly label: string | null;
          readonly name: string | null;
          readonly prefix: string | null;
        } | null> | null;
      } | null;
      readonly meetingNotesAutomationDiscoveryFragment?: {
        readonly " $fragmentSpreads": FragmentRefs<"MeetingNotesAutomationDiscoveryFragment_content">;
      } | null;
      readonly metadata: {
        readonly frontend: {
          readonly collabService: string | null;
          readonly coverPictureWidth?: string | null;
          readonly embedded: boolean;
          readonly fabricEditorSupported: boolean | null;
        } | null;
        readonly lastModifiedDate: string | null;
      };
      readonly operations: ReadonlyArray<{
        readonly operation: string | null;
        readonly targetType: string | null;
      } | null> | null;
      readonly pageContentRendererFragment: {
        readonly " $fragmentSpreads": FragmentRefs<"PageContentRenderer_content">;
      };
      readonly pageRestrictionsContext?: {
        readonly hasInheritedRestrictions: boolean;
        readonly hasRestrictions: boolean;
        readonly hasViewRestrictions: boolean;
        readonly id: string | null;
      } | null;
      readonly pageRestrictionsContextAncestors?: {
        readonly ancestors: ReadonlyArray<{
          readonly hasRestrictions: boolean;
          readonly id: string | null;
          readonly links: {
            readonly webui: string | null;
          } | null;
          readonly title: string | null;
        } | null> | null;
        readonly id: string | null;
      } | null;
      readonly pageTitlePublished?: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly properties: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly reactionsContent?: {
        readonly contentReactionsSummary: {
          readonly ari: string;
          readonly containerAri: string;
          readonly reactionsCount: number;
          readonly reactionsSummaryForEmoji: ReadonlyArray<{
            readonly count: number;
            readonly emojiId: string;
            readonly id: string;
            readonly reacted: boolean;
          } | null>;
        } | null;
        readonly id: string | null;
      } | null;
      readonly reactionsContentFragment?: {
        readonly " $fragmentSpreads": FragmentRefs<"ReactionsContentFragment_content">;
      } | null;
      readonly rendererAssetsMacroOutput?: {
        readonly " $fragmentSpreads": FragmentRefs<"ViewPageExtensionsAndRendererAssetsContentFragment_content">;
      } | null;
      readonly rendererAssetsMedia?: {
        readonly " $fragmentSpreads": FragmentRefs<"ViewPageExtensionsAndRendererAssetsContentFragment_mediaContent">;
      } | null;
      readonly rendererCoverPicture?: {
        readonly " $fragmentSpreads": FragmentRefs<"CoverPictureQuery_content">;
      } | null;
      readonly rendererTitleContentProperties?: {
        readonly " $fragmentSpreads": FragmentRefs<"useTitleContentPropertiesForPublishedPage_content">;
      } | null;
      readonly shareAndRestrictButtonData?: {
        readonly hasInheritedRestrictions: boolean;
        readonly hasRestrictions: boolean;
        readonly hasViewRestrictions: boolean;
        readonly id: string | null;
        readonly title: string | null;
      } | null;
      readonly smartFolderProperties: {
        readonly nodes: ReadonlyArray<{
          readonly key: string | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly space: {
        readonly alias: string | null;
        readonly id: string | null;
        readonly key: string | null;
        readonly name: string | null;
      } | null;
      readonly status: string | null;
      readonly subType: string | null;
      readonly title: string | null;
      readonly titleContentProperties?: {
        readonly id: string | null;
        readonly metadata: {
          readonly frontend: {
            readonly coverPictureWidth: string | null;
          } | null;
        };
        readonly pageTitleDraft: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null> | null;
        } | null;
        readonly pageTitlePublished: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null> | null;
        } | null;
      } | null;
      readonly type: string | null;
      readonly version: {
        readonly by: {
          readonly displayName: string | null;
        } | null;
        readonly confRev: string | null;
        readonly contentTypeModified: boolean | null;
        readonly friendlyWhen: string | null;
        readonly number: number | null;
        readonly when: string | null;
      } | null;
      readonly viewPageContentMode?: {
        readonly " $fragmentSpreads": FragmentRefs<"ContentModeFragmentProvider_content">;
      } | null;
      readonly viewPageLabels?: {
        readonly " $fragmentSpreads": FragmentRefs<"ViewPageLabelsContentFragment_content">;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"PageStatusQueryRelaySpike_content" | "PresenterModePortal_content">;
    } | null> | null;
  } | null;
  readonly contentContributors?: {
    readonly " $fragmentSpreads": FragmentRefs<"ByLineContributors_contentContributors">;
  } | null;
  readonly dataSecurityPolicy?: {
    readonly isActionEnabledForContent: {
      readonly action: DataSecurityPolicyAction | null;
      readonly allowed: boolean | null;
    };
  } | null;
  readonly mediaConfiguration?: {
    readonly clientId: string;
    readonly fileStoreUrl: string;
  } | null;
  readonly publicLinkPage?: {
    readonly accessType: ConfluenceShareableLinkAccessType | null;
    readonly pageId: string;
    readonly pageStatus: PublicLinkPageStatus;
  } | null;
  readonly space: {
    readonly contentHeaderFragment?: {
      readonly " $fragmentSpreads": FragmentRefs<"ContentHeader_space">;
    } | null;
    readonly currentUser: {
      readonly isAnonymouslyAuthorized: boolean;
    };
    readonly id: string | null;
    readonly lookAndFeel: {
      readonly content: {
        readonly container: {
          readonly background: string | null;
          readonly backgroundAttachment: string | null;
          readonly backgroundBlendMode: string | null;
          readonly backgroundClip: string | null;
          readonly backgroundColor: string | null;
          readonly backgroundImage: string | null;
          readonly backgroundOrigin: string | null;
          readonly backgroundPosition: string | null;
          readonly backgroundRepeat: string | null;
          readonly backgroundSize: string | null;
          readonly borderRadius: string | null;
          readonly padding: string | null;
        } | null;
        readonly screen: {
          readonly background: string | null;
          readonly backgroundAttachment: string | null;
          readonly backgroundBlendMode: string | null;
          readonly backgroundClip: string | null;
          readonly backgroundColor: string | null;
          readonly backgroundImage: string | null;
          readonly backgroundOrigin: string | null;
          readonly backgroundPosition: string | null;
          readonly backgroundRepeat: string | null;
          readonly backgroundSize: string | null;
          readonly gutterBottom: string | null;
          readonly gutterLeft: string | null;
          readonly gutterRight: string | null;
          readonly gutterTop: string | null;
          readonly layer: {
            readonly background: string | null;
            readonly backgroundAttachment: string | null;
            readonly backgroundBlendMode: string | null;
            readonly backgroundClip: string | null;
            readonly backgroundColor: string | null;
            readonly backgroundImage: string | null;
            readonly backgroundOrigin: string | null;
            readonly backgroundPosition: string | null;
            readonly backgroundRepeat: string | null;
            readonly backgroundSize: string | null;
            readonly height: string | null;
            readonly width: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
    readonly pageContentRendererFragment: {
      readonly " $fragmentSpreads": FragmentRefs<"PageContentRenderer_space">;
    };
    readonly settings: {
      readonly customHeaderAndFooter: {
        readonly footer: {
          readonly css: string;
          readonly html: string;
          readonly js: ReadonlyArray<string | null>;
          readonly spaUnfriendlyMacros: ReadonlyArray<{
            readonly name: string | null;
          }>;
        };
        readonly header: {
          readonly css: string;
          readonly html: string;
          readonly js: ReadonlyArray<string | null>;
          readonly spaUnfriendlyMacros: ReadonlyArray<{
            readonly name: string | null;
          }>;
        };
      };
      readonly routeOverrideEnabled?: boolean | null;
    } | null;
    readonly theme: {
      readonly name: string | null;
      readonly themeKey: string | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"ContentContainerTheme_space" | "ContentTitle_space">;
  } | null;
};
export type ContentUnifiedQuery$rawResponse = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly agentSessionsMarker?: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly ancestors?: ReadonlyArray<{
        readonly hasRestrictions: boolean;
        readonly id: string | null;
        readonly links: {
          readonly webui: string | null;
        } | null;
        readonly title: string | null;
      } | null> | null;
      readonly appearancePublished: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly audioProperties?: {
        readonly nodes: ReadonlyArray<{
          readonly key: string | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly body: {
        readonly atlas_doc_format?: {
          readonly mediaToken: {
            readonly token: string | null;
          } | null;
        } | null;
        readonly dynamic: {
          readonly content: {
            readonly id: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null;
          readonly representation: string | null;
          readonly value: string | null;
          readonly webresource: {
            readonly superbatch: {
              readonly tags: {
                readonly css: string | null;
                readonly js: string | null;
              } | null;
            } | null;
            readonly tags: {
              readonly css: string | null;
              readonly js: string | null;
            } | null;
          } | null;
        } | null;
      } | null;
      readonly classificationLevelDetails?: {
        readonly canManageSpaceSettings: boolean;
        readonly classificationControlSetting: string | null;
        readonly classificationLevel: {
          readonly color: string | null;
          readonly description: string | null;
          readonly guideline: string | null;
          readonly guidelineADF: string | null;
          readonly id: string;
          readonly name: string;
          readonly status: string;
        } | null;
        readonly featureEnabled: boolean;
        readonly isReclassificationPermitted: boolean;
        readonly source: ClassificationLevelSource | null;
        readonly userOverrideSetting: string | null;
      } | null;
      readonly contentProperties: {
        readonly draft: {
          readonly contentMode: string | null;
        } | null;
        readonly latest: {
          readonly contentMode: string | null;
          readonly generatedBy: string | null;
        } | null;
      } | null;
      readonly contentReactionsSummary?: {
        readonly ari: string;
        readonly containerAri: string;
        readonly reactionsCount: number;
        readonly reactionsSummaryForEmoji: ReadonlyArray<{
          readonly count: number;
          readonly emojiId: string;
          readonly id: string;
          readonly reacted: boolean;
        } | null>;
      } | null;
      readonly contentState: {
        readonly color: string;
        readonly id: string | null;
        readonly name: string;
        readonly restrictionLevel: ContentStateRestrictionLevel;
      } | null;
      readonly contentStateLastUpdated: {
        readonly value: string;
      } | null;
      readonly coverPictureProperties?: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly draftVersion: {
        readonly by: {
          readonly __typename: string;
          readonly displayName: string | null;
        } | null;
        readonly contentTypeModified: boolean | null;
        readonly friendlyWhen: string | null;
        readonly number: number | null;
        readonly when: string | null;
      } | null;
      readonly editorProperty?: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly emoji?: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly emojiTitlePublished?: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly hasInheritedRestrictions?: boolean;
      readonly hasRestrictions?: boolean;
      readonly hasViewRestrictions?: boolean;
      readonly history?: {
        readonly createdBy: {
          readonly __typename: "KnownUser";
          readonly accountId: string | null;
          readonly displayName: string | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
          readonly type: string | null;
        } | {
          readonly __typename: string;
          readonly displayName: string | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
          readonly type: string | null;
        } | null;
        readonly createdDate: string | null;
        readonly lastOwnedBy: {
          readonly __typename: "KnownUser";
          readonly accountId: string | null;
          readonly displayName: string | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
          readonly type: string | null;
        } | {
          readonly __typename: string;
          readonly displayName: string | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
          readonly type: string | null;
        } | null;
        readonly ownedBy: {
          readonly __typename: "KnownUser";
          readonly accountId: string | null;
          readonly displayName: string | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
          readonly type: string | null;
        } | {
          readonly __typename: string;
          readonly displayName: string | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
          readonly type: string | null;
        } | null;
      } | null;
      readonly id: string | null;
      readonly labels?: {
        readonly count: number | null;
        readonly nodes: ReadonlyArray<{
          readonly __typename: "Label";
          readonly id: string | null;
          readonly label: string | null;
          readonly name: string | null;
          readonly prefix: string | null;
        } | null> | null;
      } | null;
      readonly links?: {
        readonly base: string | null;
        readonly webui: string | null;
      } | null;
      readonly macroRenderedOutput?: ReadonlyArray<{
        readonly key: string | null;
        readonly value: {
          readonly representation: string | null;
          readonly value: string | null;
          readonly webresource: {
            readonly tags: {
              readonly css: string | null;
              readonly js: string | null;
            } | null;
          } | null;
        } | null;
      } | null> | null;
      readonly metadata: {
        readonly frontend: {
          readonly collabService: string | null;
          readonly contentHash?: string | null;
          readonly coverPictureWidth: string | null;
          readonly embedded: boolean;
          readonly fabricEditorEligibility?: string | null;
          readonly fabricEditorSupported: boolean | null;
        } | null;
        readonly lastModifiedDate: string | null;
        readonly sourceTemplateEntityId: string | null;
      };
      readonly operations: ReadonlyArray<{
        readonly operation: string | null;
        readonly targetType: string | null;
      } | null> | null;
      readonly pageTitleDraft?: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly pageTitlePublished?: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly properties: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly smartFolderProperties: {
        readonly nodes: ReadonlyArray<{
          readonly key: string | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly space: {
        readonly alias: string | null;
        readonly homepageId?: string | null;
        readonly id: string | null;
        readonly key: string | null;
        readonly name: string | null;
      } | null;
      readonly status: string | null;
      readonly subType: string | null;
      readonly title: string | null;
      readonly type: string | null;
      readonly version: {
        readonly by: {
          readonly __typename: "KnownUser";
          readonly accountId?: string | null;
          readonly displayName: string | null;
          readonly profilePicture?: {
            readonly path: string;
          } | null;
          readonly type?: string | null;
        } | {
          readonly __typename: string;
          readonly displayName: string | null;
          readonly profilePicture?: {
            readonly path: string;
          } | null;
          readonly type?: string | null;
        } | null;
        readonly confRev: string | null;
        readonly contentTypeModified: boolean | null;
        readonly friendlyWhen: string | null;
        readonly number: number | null;
        readonly when: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly contentAnalyticsViewers?: {
    readonly count: number;
  } | null;
  readonly contentContributors?: {
    readonly count: number | null;
    readonly isCurrentUserContributor: boolean | null;
    readonly isOwnerContributor: boolean | null;
    readonly nodes: ReadonlyArray<{
      readonly __typename: "KnownUser";
      readonly accountId: string | null;
      readonly displayName: string | null;
      readonly profilePicture: {
        readonly path: string;
      } | null;
      readonly type: string | null;
    } | {
      readonly __typename: string;
      readonly displayName: string | null;
      readonly profilePicture: {
        readonly path: string;
      } | null;
      readonly type: string | null;
    } | null> | null;
  } | null;
  readonly dataSecurityPolicy?: {
    readonly isActionEnabledForContent: {
      readonly action: DataSecurityPolicyAction | null;
      readonly allowed: boolean | null;
    };
  } | null;
  readonly knowledgeDiscovery?: {
    readonly keyPhrases: {
      readonly __typename: "KnowledgeDiscoveryKeyPhraseConnection";
      readonly nodes: ReadonlyArray<{
        readonly category: KnowledgeDiscoveryKeyPhraseCategory;
        readonly keyPhrase: string;
      } | null> | null;
    } | {
      readonly __typename: "QueryError";
      readonly message: string | null;
    } | {
      readonly __typename: string;
    } | null;
  } | null;
  readonly mediaConfiguration?: {
    readonly clientId: string;
    readonly fileStoreUrl: string;
  } | null;
  readonly publicLinkPage?: {
    readonly accessType: ConfluenceShareableLinkAccessType | null;
    readonly pageId: string;
    readonly pageStatus: PublicLinkPageStatus;
  } | null;
  readonly space: {
    readonly currentUser: {
      readonly isAnonymouslyAuthorized: boolean;
    };
    readonly id: string | null;
    readonly lookAndFeel: {
      readonly content: {
        readonly container: {
          readonly background: string | null;
          readonly backgroundAttachment: string | null;
          readonly backgroundBlendMode: string | null;
          readonly backgroundClip: string | null;
          readonly backgroundColor: string | null;
          readonly backgroundImage: string | null;
          readonly backgroundOrigin: string | null;
          readonly backgroundPosition: string | null;
          readonly backgroundRepeat: string | null;
          readonly backgroundSize: string | null;
          readonly borderRadius: string | null;
          readonly padding: string | null;
        } | null;
        readonly header: {
          readonly background: string | null;
          readonly backgroundAttachment: string | null;
          readonly backgroundBlendMode: string | null;
          readonly backgroundClip: string | null;
          readonly backgroundColor: string | null;
          readonly backgroundImage: string | null;
          readonly backgroundOrigin: string | null;
          readonly backgroundPosition: string | null;
          readonly backgroundRepeat: string | null;
          readonly backgroundSize: string | null;
          readonly borderRadius: string | null;
          readonly padding: string | null;
        } | null;
        readonly screen: {
          readonly background: string | null;
          readonly backgroundAttachment: string | null;
          readonly backgroundBlendMode: string | null;
          readonly backgroundClip: string | null;
          readonly backgroundColor: string | null;
          readonly backgroundImage: string | null;
          readonly backgroundOrigin: string | null;
          readonly backgroundPosition: string | null;
          readonly backgroundRepeat: string | null;
          readonly backgroundSize: string | null;
          readonly gutterBottom: string | null;
          readonly gutterLeft: string | null;
          readonly gutterRight: string | null;
          readonly gutterTop: string | null;
          readonly layer: {
            readonly background: string | null;
            readonly backgroundAttachment: string | null;
            readonly backgroundBlendMode: string | null;
            readonly backgroundClip: string | null;
            readonly backgroundColor: string | null;
            readonly backgroundImage: string | null;
            readonly backgroundOrigin: string | null;
            readonly backgroundPosition: string | null;
            readonly backgroundRepeat: string | null;
            readonly backgroundSize: string | null;
            readonly height: string | null;
            readonly width: string | null;
          } | null;
        } | null;
      } | null;
      readonly headings: ReadonlyArray<{
        readonly key: string | null;
        readonly value: string | null;
      } | null>;
    } | null;
    readonly settings: {
      readonly customHeaderAndFooter?: {
        readonly footer: {
          readonly css: string;
          readonly html: string;
          readonly js: ReadonlyArray<string | null>;
          readonly spaUnfriendlyMacros: ReadonlyArray<{
            readonly name: string | null;
          }>;
        };
        readonly header: {
          readonly css: string;
          readonly html: string;
          readonly js: ReadonlyArray<string | null>;
          readonly spaUnfriendlyMacros: ReadonlyArray<{
            readonly name: string | null;
          }>;
        };
      };
      readonly routeOverrideEnabled: boolean | null;
    } | null;
    readonly theme: {
      readonly name: string | null;
      readonly themeKey: string | null;
    } | null;
  } | null;
  readonly user?: {
    readonly confluence: {
      readonly permissionType: SitePermissionType | null;
    } | null;
    readonly id: string | null;
  } | null;
};
export type ContentUnifiedQuery = {
  rawResponse: ContentUnifiedQuery$rawResponse;
  response: ContentUnifiedQuery$data;
  variables: ContentUnifiedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "agentSessionsPropertyKey"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "autohighlightsEntityAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "autohighlightsWorkspaceId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bylineContributorsLimit"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v5 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchAgentSessionsMarker"
},
v6 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAgentTrustReceiptData"
},
v7 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAnalyticsByline"
},
v8 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAudioContent"
},
v9 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAutohighlights"
},
v10 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAutomationDiscoveries"
},
v11 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeBylineContributors"
},
v12 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeClassification"
},
v13 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeContentHeader"
},
v14 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeContentHeaderAccess"
},
v15 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeContentHeaderPublicLink"
},
v16 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeFabricEditorEligibility"
},
v17 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeReactions"
},
v18 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeRendererAssetsCustomChrome"
},
v19 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeRendererAssetsDsp"
},
v20 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeRendererAssetsMedia"
},
v21 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeRestrictionAncestors"
},
v22 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeRestrictions"
},
v23 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isSSR"
},
v24 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "preloadLabels"
},
v25 = {
  "defaultValue": "PAGE_EXPORT",
  "kind": "LocalArgument",
  "name": "rendererAssetsDspAction"
},
v26 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v27 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "useContentModeFragment"
},
v28 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "useNewContentTopper"
},
v29 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "versionOverride"
},
v30 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "contentId"
},
v31 = [
  (v30/*: any*/),
  {
    "kind": "Variable",
    "name": "version",
    "variableName": "versionOverride"
  }
],
v32 = {
  "kind": "ScalarField",
  "name": "id"
},
v33 = {
  "concreteType": "OperationCheckResult",
  "kind": "LinkedField",
  "name": "operations",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "operation"
    },
    {
      "kind": "ScalarField",
      "name": "targetType"
    }
  ]
},
v34 = {
  "kind": "ScalarField",
  "name": "type"
},
v35 = {
  "kind": "ScalarField",
  "name": "status"
},
v36 = [
  {
    "kind": "ScalarField",
    "name": "contentMode"
  }
],
v37 = {
  "concreteType": "ContentProperties",
  "kind": "LinkedField",
  "name": "contentProperties",
  "plural": false,
  "selections": [
    {
      "concreteType": "PublishedContentProperties",
      "kind": "LinkedField",
      "name": "latest",
      "plural": false,
      "selections": (v36/*: any*/)
    },
    {
      "concreteType": "DraftContentProperties",
      "kind": "LinkedField",
      "name": "draft",
      "plural": false,
      "selections": (v36/*: any*/)
    }
  ]
},
v38 = {
  "kind": "ScalarField",
  "name": "name"
},
v39 = {
  "kind": "ScalarField",
  "name": "color"
},
v40 = {
  "args": [
    {
      "kind": "Literal",
      "name": "isDraft",
      "value": false
    }
  ],
  "concreteType": "ContentState",
  "kind": "LinkedField",
  "name": "contentState",
  "plural": false,
  "selections": [
    (v32/*: any*/),
    (v38/*: any*/),
    (v39/*: any*/),
    {
      "kind": "ScalarField",
      "name": "restrictionLevel"
    }
  ],
  "storageKey": "contentState(isDraft:false)"
},
v41 = {
  "kind": "ScalarField",
  "name": "value"
},
v42 = {
  "args": [
    {
      "kind": "Literal",
      "name": "format",
      "value": "USER_FRIENDLY"
    }
  ],
  "concreteType": "ConfluenceDate",
  "kind": "LinkedField",
  "name": "contentStateLastUpdated",
  "plural": false,
  "selections": [
    (v41/*: any*/)
  ],
  "storageKey": "contentStateLastUpdated(format:\"USER_FRIENDLY\")"
},
v43 = {
  "kind": "ScalarField",
  "name": "title"
},
v44 = {
  "kind": "ScalarField",
  "name": "key"
},
v45 = {
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v32/*: any*/),
    (v38/*: any*/),
    (v44/*: any*/),
    {
      "kind": "ScalarField",
      "name": "alias"
    }
  ]
},
v46 = {
  "kind": "ScalarField",
  "name": "subType"
},
v47 = [
  (v44/*: any*/),
  (v41/*: any*/)
],
v48 = {
  "alias": "smartFolderProperties",
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "smartFolderProperties"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": (v47/*: any*/)
    }
  ],
  "storageKey": "properties(keys:[\"smartFolderProperties\"])"
},
v49 = {
  "kind": "ScalarField",
  "name": "contentTypeModified"
},
v50 = {
  "kind": "ScalarField",
  "name": "number"
},
v51 = {
  "kind": "ScalarField",
  "name": "friendlyWhen"
},
v52 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v53 = [
  (v52/*: any*/)
],
v54 = {
  "kind": "LinkedField",
  "name": "by",
  "plural": false,
  "selections": (v53/*: any*/)
},
v55 = {
  "kind": "ScalarField",
  "name": "when"
},
v56 = {
  "kind": "ScalarField",
  "name": "confRev"
},
v57 = [
  {
    "kind": "ScalarField",
    "name": "coverPictureWidth"
  }
],
v58 = {
  "concreteType": "ContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
      "kind": "LinkedField",
      "name": "frontend",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "fabricEditorSupported"
        },
        {
          "kind": "ScalarField",
          "name": "embedded"
        },
        {
          "kind": "ScalarField",
          "name": "collabService"
        },
        {
          "condition": "useNewContentTopper",
          "kind": "Condition",
          "passingValue": true,
          "selections": (v57/*: any*/)
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    }
  ]
},
v59 = {
  "kind": "ScalarField",
  "name": "representation"
},
v60 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    (v50/*: any*/)
  ]
},
v61 = {
  "kind": "ScalarField",
  "name": "js"
},
v62 = {
  "kind": "ScalarField",
  "name": "css"
},
v63 = {
  "concreteType": "WebResourceTags",
  "kind": "LinkedField",
  "name": "tags",
  "plural": false,
  "selections": [
    (v61/*: any*/),
    (v62/*: any*/)
  ]
},
v64 = [
  (v63/*: any*/)
],
v65 = {
  "concreteType": "ContentBodyPerRepresentation",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": [
    {
      "concreteType": "ContentBody",
      "kind": "LinkedField",
      "name": "dynamic",
      "plural": false,
      "selections": [
        (v59/*: any*/),
        (v41/*: any*/),
        {
          "concreteType": "Content",
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            (v32/*: any*/),
            (v60/*: any*/)
          ]
        },
        {
          "concreteType": "WebResourceDependencies",
          "kind": "LinkedField",
          "name": "webresource",
          "plural": false,
          "selections": [
            {
              "concreteType": "SuperBatchWebResources",
              "kind": "LinkedField",
              "name": "superbatch",
              "plural": false,
              "selections": (v64/*: any*/)
            },
            (v63/*: any*/)
          ]
        }
      ]
    }
  ]
},
v66 = [
  {
    "concreteType": "JsonContentProperty",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v32/*: any*/),
      (v44/*: any*/),
      (v41/*: any*/),
      (v60/*: any*/)
    ]
  }
],
v67 = {
  "alias": "appearancePublished",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "content-appearance-published"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v66/*: any*/),
  "storageKey": "properties(key:\"content-appearance-published\")"
},
v68 = {
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "cover-picture-id-published",
        "emoji-title-published",
        "editor",
        "import-source",
        "imported-page-modified-date"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v66/*: any*/),
  "storageKey": "properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"])"
},
v69 = {
  "alias": "pageTitlePublished",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "page-title-property-published"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v66/*: any*/),
  "storageKey": "properties(key:\"page-title-property-published\")"
},
v70 = {
  "alias": "pageTitleDraft",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "page-title-property-draft"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v66/*: any*/),
  "storageKey": "properties(key:\"page-title-property-draft\")"
},
v71 = {
  "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
  "kind": "LinkedField",
  "name": "frontend",
  "plural": false,
  "selections": (v57/*: any*/)
},
v72 = {
  "concreteType": "ContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    (v71/*: any*/)
  ]
},
v73 = {
  "alias": "coverPictureProperties",
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "cover-picture-id-draft",
        "cover-picture-id-published"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v66/*: any*/),
  "storageKey": "properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])"
},
v74 = {
  "kind": "ScalarField",
  "name": "hasInheritedRestrictions"
},
v75 = {
  "kind": "ScalarField",
  "name": "hasRestrictions"
},
v76 = {
  "kind": "ScalarField",
  "name": "hasViewRestrictions"
},
v77 = [
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": {
      "direction": "ASCENDING",
      "sortField": "LABELLING_CREATIONDATE"
    }
  }
],
v78 = {
  "kind": "ScalarField",
  "name": "count"
},
v79 = {
  "kind": "ScalarField",
  "name": "label"
},
v80 = {
  "kind": "ScalarField",
  "name": "prefix"
},
v81 = {
  "concreteType": "ReactionsSummaryResponse",
  "kind": "LinkedField",
  "name": "contentReactionsSummary",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "reactionsCount"
    },
    {
      "kind": "ScalarField",
      "name": "ari"
    },
    {
      "kind": "ScalarField",
      "name": "containerAri"
    },
    {
      "concreteType": "ReactionsSummaryForEmoji",
      "kind": "LinkedField",
      "name": "reactionsSummaryForEmoji",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "emojiId"
        },
        (v78/*: any*/),
        {
          "kind": "ScalarField",
          "name": "reacted"
        },
        (v32/*: any*/)
      ]
    }
  ]
},
v82 = [
  {
    "kind": "Literal",
    "name": "key",
    "value": "emoji-title-published"
  }
],
v83 = {
  "alias": "emoji",
  "args": (v82/*: any*/),
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v32/*: any*/),
        (v41/*: any*/)
      ]
    }
  ],
  "storageKey": "properties(key:\"emoji-title-published\")"
},
v84 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v85 = [
  (v52/*: any*/),
  (v84/*: any*/)
],
v86 = {
  "kind": "ScalarField",
  "name": "webui"
},
v87 = {
  "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    (v86/*: any*/),
    {
      "kind": "ScalarField",
      "name": "base"
    }
  ]
},
v88 = {
  "alias": "audioProperties",
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "emoji-title-published",
        "editor"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v41/*: any*/),
        (v44/*: any*/)
      ]
    }
  ],
  "storageKey": "properties(keys:[\"emoji-title-published\",\"editor\"])"
},
v89 = {
  "concreteType": "Content",
  "kind": "LinkedField",
  "name": "ancestors",
  "plural": true,
  "selections": [
    (v32/*: any*/),
    (v43/*: any*/),
    (v75/*: any*/),
    {
      "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": [
        (v86/*: any*/)
      ]
    }
  ]
},
v90 = {
  "concreteType": "ClassificationLevelDetails",
  "kind": "LinkedField",
  "name": "classificationLevelDetails",
  "plural": false,
  "selections": [
    {
      "concreteType": "ContentDataClassificationLevel",
      "kind": "LinkedField",
      "name": "classificationLevel",
      "plural": false,
      "selections": [
        (v32/*: any*/),
        {
          "kind": "ScalarField",
          "name": "guideline"
        },
        {
          "kind": "ScalarField",
          "name": "guidelineADF"
        },
        {
          "kind": "ScalarField",
          "name": "description"
        },
        (v39/*: any*/),
        (v38/*: any*/),
        (v35/*: any*/)
      ]
    },
    {
      "kind": "ScalarField",
      "name": "featureEnabled"
    },
    {
      "kind": "ScalarField",
      "name": "source"
    },
    {
      "kind": "ScalarField",
      "name": "isReclassificationPermitted"
    },
    {
      "kind": "ScalarField",
      "name": "canManageSpaceSettings"
    },
    {
      "kind": "ScalarField",
      "name": "classificationControlSetting"
    },
    {
      "kind": "ScalarField",
      "name": "userOverrideSetting"
    }
  ]
},
v91 = {
  "kind": "ScalarField",
  "name": "createdDate"
},
v92 = {
  "concreteType": "ContentProperties",
  "kind": "LinkedField",
  "name": "contentProperties",
  "plural": false,
  "selections": [
    {
      "concreteType": "PublishedContentProperties",
      "kind": "LinkedField",
      "name": "latest",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "generatedBy"
        }
      ]
    }
  ]
},
v93 = {
  "condition": "fetchAgentSessionsMarker",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "agentSessionsMarker",
      "args": [
        {
          "kind": "Variable",
          "name": "key",
          "variableName": "agentSessionsPropertyKey"
        }
      ],
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": (v66/*: any*/)
    }
  ]
},
v94 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "spaceKey"
  }
],
v95 = {
  "kind": "ScalarField",
  "name": "themeKey"
},
v96 = {
  "kind": "ScalarField",
  "name": "background"
},
v97 = {
  "kind": "ScalarField",
  "name": "backgroundColor"
},
v98 = {
  "kind": "ScalarField",
  "name": "backgroundImage"
},
v99 = {
  "kind": "ScalarField",
  "name": "backgroundPosition"
},
v100 = {
  "kind": "ScalarField",
  "name": "backgroundSize"
},
v101 = {
  "kind": "ScalarField",
  "name": "backgroundRepeat"
},
v102 = {
  "kind": "ScalarField",
  "name": "backgroundOrigin"
},
v103 = {
  "kind": "ScalarField",
  "name": "backgroundClip"
},
v104 = {
  "kind": "ScalarField",
  "name": "backgroundAttachment"
},
v105 = {
  "kind": "ScalarField",
  "name": "backgroundBlendMode"
},
v106 = {
  "concreteType": "ScreenLookAndFeel",
  "kind": "LinkedField",
  "name": "screen",
  "plural": false,
  "selections": [
    (v96/*: any*/),
    (v97/*: any*/),
    (v98/*: any*/),
    (v99/*: any*/),
    (v100/*: any*/),
    (v101/*: any*/),
    (v102/*: any*/),
    (v103/*: any*/),
    (v104/*: any*/),
    (v105/*: any*/),
    {
      "concreteType": "LayerScreenLookAndFeel",
      "kind": "LinkedField",
      "name": "layer",
      "plural": false,
      "selections": [
        (v96/*: any*/),
        (v97/*: any*/),
        (v98/*: any*/),
        (v99/*: any*/),
        (v100/*: any*/),
        (v101/*: any*/),
        (v102/*: any*/),
        (v103/*: any*/),
        (v104/*: any*/),
        (v105/*: any*/),
        {
          "kind": "ScalarField",
          "name": "width"
        },
        {
          "kind": "ScalarField",
          "name": "height"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "gutterTop"
    },
    {
      "kind": "ScalarField",
      "name": "gutterRight"
    },
    {
      "kind": "ScalarField",
      "name": "gutterBottom"
    },
    {
      "kind": "ScalarField",
      "name": "gutterLeft"
    }
  ]
},
v107 = {
  "kind": "ScalarField",
  "name": "padding"
},
v108 = {
  "kind": "ScalarField",
  "name": "borderRadius"
},
v109 = {
  "concreteType": "ContainerLookAndFeel",
  "kind": "LinkedField",
  "name": "container",
  "plural": false,
  "selections": [
    (v96/*: any*/),
    (v97/*: any*/),
    (v98/*: any*/),
    (v99/*: any*/),
    (v100/*: any*/),
    (v101/*: any*/),
    (v102/*: any*/),
    (v103/*: any*/),
    (v104/*: any*/),
    (v105/*: any*/),
    (v107/*: any*/),
    (v108/*: any*/)
  ]
},
v110 = {
  "concreteType": "SpaceSettings",
  "kind": "LinkedField",
  "name": "settings",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "routeOverrideEnabled"
    }
  ]
},
v111 = {
  "concreteType": "SpaceUserMetadata",
  "kind": "LinkedField",
  "name": "currentUser",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isAnonymouslyAuthorized"
    }
  ]
},
v112 = [
  {
    "kind": "ScalarField",
    "name": "html"
  },
  (v61/*: any*/),
  (v62/*: any*/),
  {
    "concreteType": "SpaUnfriendlyMacro",
    "kind": "LinkedField",
    "name": "spaUnfriendlyMacros",
    "plural": true,
    "selections": [
      (v38/*: any*/)
    ]
  }
],
v113 = {
  "condition": "includeRendererAssetsCustomChrome",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "SpaceSettings",
      "kind": "LinkedField",
      "name": "settings",
      "plural": false,
      "selections": [
        {
          "concreteType": "SpaceSettingsMetadata",
          "kind": "LinkedField",
          "name": "customHeaderAndFooter",
          "plural": false,
          "selections": [
            {
              "concreteType": "HtmlMeta",
              "kind": "LinkedField",
              "name": "header",
              "plural": false,
              "selections": (v112/*: any*/)
            },
            {
              "concreteType": "HtmlMeta",
              "kind": "LinkedField",
              "name": "footer",
              "plural": false,
              "selections": (v112/*: any*/)
            }
          ]
        }
      ]
    }
  ]
},
v114 = {
  "condition": "includeRendererAssetsMedia",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "MediaConfiguration",
      "kind": "LinkedField",
      "name": "mediaConfiguration",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "clientId"
        },
        {
          "kind": "ScalarField",
          "name": "fileStoreUrl"
        }
      ]
    }
  ]
},
v115 = {
  "kind": "Variable",
  "name": "contentId",
  "variableName": "contentId"
},
v116 = {
  "condition": "includeRendererAssetsDsp",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "Confluence_dataSecurityPolicy",
      "kind": "LinkedField",
      "name": "dataSecurityPolicy",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "action",
              "variableName": "rendererAssetsDspAction"
            },
            (v115/*: any*/),
            {
              "kind": "Literal",
              "name": "contentStatus",
              "value": "CURRENT"
            },
            {
              "kind": "Literal",
              "name": "contentVersion",
              "value": 1
            },
            {
              "kind": "Variable",
              "name": "spaceKey",
              "variableName": "spaceKey"
            }
          ],
          "concreteType": "DataSecurityPolicyDecision",
          "kind": "LinkedField",
          "name": "isActionEnabledForContent",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "action"
            },
            {
              "kind": "ScalarField",
              "name": "allowed"
            }
          ]
        }
      ]
    }
  ]
},
v117 = [
  {
    "kind": "Variable",
    "name": "entityAri",
    "variableName": "autohighlightsEntityAri"
  },
  {
    "kind": "Variable",
    "name": "workspaceId",
    "variableName": "autohighlightsWorkspaceId"
  }
],
v118 = [
  (v115/*: any*/)
],
v119 = {
  "condition": "includeContentHeaderPublicLink",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "pageId",
          "variableName": "contentId"
        }
      ],
      "concreteType": "PublicLinkPage",
      "kind": "LinkedField",
      "name": "publicLinkPage",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "pageId"
        },
        {
          "kind": "ScalarField",
          "name": "pageStatus"
        },
        {
          "kind": "ScalarField",
          "name": "accessType"
        }
      ]
    }
  ]
},
v120 = [
  (v30/*: any*/),
  {
    "kind": "Variable",
    "name": "limit",
    "variableName": "bylineContributorsLimit"
  }
],
v121 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v122 = [
  (v121/*: any*/),
  (v52/*: any*/)
],
v123 = {
  "kind": "LinkedField",
  "name": "by",
  "plural": false,
  "selections": (v122/*: any*/)
},
v124 = {
  "kind": "ScalarField",
  "name": "sourceTemplateEntityId"
},
v125 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v126 = [
  (v121/*: any*/),
  (v34/*: any*/),
  (v52/*: any*/),
  (v125/*: any*/),
  (v84/*: any*/)
],
v127 = [
  (v74/*: any*/),
  (v75/*: any*/),
  (v76/*: any*/)
],
v128 = [
  (v121/*: any*/),
  (v52/*: any*/),
  (v84/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      (v28/*: any*/),
      (v29/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ContentUnifiedQuery",
    "selections": [
      {
        "args": (v31/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v37/*: any*/),
              (v40/*: any*/),
              (v42/*: any*/),
              (v43/*: any*/),
              (v45/*: any*/),
              (v46/*: any*/),
              (v48/*: any*/),
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v49/*: any*/),
                  (v50/*: any*/),
                  (v51/*: any*/),
                  (v54/*: any*/),
                  (v55/*: any*/),
                  (v56/*: any*/)
                ]
              },
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "draftVersion",
                "plural": false,
                "selections": [
                  (v49/*: any*/),
                  (v50/*: any*/),
                  (v51/*: any*/),
                  (v54/*: any*/),
                  (v55/*: any*/)
                ]
              },
              (v58/*: any*/),
              (v65/*: any*/),
              (v67/*: any*/),
              (v68/*: any*/),
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "ViewPageCommentsPanelPermission_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "commentsPanelPermission"
              },
              {
                "kind": "FragmentSpread",
                "name": "PageStatusQueryRelaySpike_content"
              },
              {
                "kind": "FragmentSpread",
                "name": "PresenterModePortal_content"
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "ArchivedPageBannerV2Status_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "archivedPageBannerStatusFragment"
              },
              {
                "condition": "useContentModeFragment",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "ContentModeFragmentProvider_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "viewPageContentMode"
                  }
                ]
              },
              {
                "condition": "includeBylineContributors",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "args": [
                            {
                              "kind": "Variable",
                              "name": "useNewContentTopper",
                              "variableName": "useNewContentTopper"
                            }
                          ],
                          "kind": "FragmentSpread",
                          "name": "ContentTitleWithByLine_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "contentTitleWithByLine"
                  },
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "useTitleContentPropertiesForPublishedPage_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "rendererTitleContentProperties"
                  },
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "CoverPictureQuery_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "rendererCoverPicture"
                  }
                ]
              },
              {
                "condition": "includeAutomationDiscoveries",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "MeetingNotesAutomationDiscoveryFragment_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "meetingNotesAutomationDiscoveryFragment"
                  }
                ]
              },
              {
                "condition": "includeContentHeader",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "args": [
                            {
                              "kind": "Variable",
                              "name": "includeAccessButton",
                              "variableName": "includeContentHeaderAccess"
                            },
                            {
                              "kind": "Variable",
                              "name": "includeFabricEditorEligibility",
                              "variableName": "includeFabricEditorEligibility"
                            }
                          ],
                          "kind": "FragmentSpread",
                          "name": "ContentHeader_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "contentHeaderFragment"
                  }
                ]
              },
              {
                "condition": "useNewContentTopper",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        (v32/*: any*/),
                        (v69/*: any*/),
                        (v70/*: any*/),
                        (v72/*: any*/)
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "titleContentProperties"
                  },
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        (v32/*: any*/),
                        (v73/*: any*/)
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "coverPicture"
                  },
                  (v69/*: any*/)
                ]
              },
              {
                "condition": "includeRestrictions",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        (v32/*: any*/),
                        (v74/*: any*/),
                        (v75/*: any*/),
                        (v76/*: any*/),
                        (v43/*: any*/)
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "shareAndRestrictButtonData"
                  },
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        (v32/*: any*/),
                        (v74/*: any*/),
                        (v76/*: any*/),
                        (v75/*: any*/)
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "pageRestrictionsContext"
                  }
                ]
              },
              {
                "condition": "preloadLabels",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "ViewPageLabelsContentFragment_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "viewPageLabels"
                  },
                  {
                    "args": (v77/*: any*/),
                    "concreteType": "PaginatedLabelList",
                    "kind": "LinkedField",
                    "name": "labels",
                    "plural": false,
                    "selections": [
                      (v78/*: any*/),
                      {
                        "concreteType": "Label",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v32/*: any*/),
                          (v79/*: any*/),
                          (v38/*: any*/),
                          (v80/*: any*/)
                        ]
                      }
                    ],
                    "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
                  }
                ]
              },
              {
                "condition": "includeReactions",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        (v32/*: any*/),
                        (v81/*: any*/)
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "reactionsContent"
                  },
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "ReactionsContentFragment_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "reactionsContentFragment"
                  }
                ]
              },
              {
                "condition": "includeAudioContent",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        (v32/*: any*/),
                        (v43/*: any*/),
                        (v46/*: any*/),
                        (v83/*: any*/),
                        {
                          "concreteType": "History",
                          "kind": "LinkedField",
                          "name": "history",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "name": "createdBy",
                              "plural": false,
                              "selections": (v85/*: any*/)
                            },
                            {
                              "kind": "LinkedField",
                              "name": "ownedBy",
                              "plural": false,
                              "selections": (v85/*: any*/)
                            }
                          ]
                        },
                        (v87/*: any*/),
                        (v88/*: any*/)
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "audioContent"
                  },
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "AudioContentFragment_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "audioContentFragment"
                  }
                ]
              },
              {
                "condition": "includeRestrictionAncestors",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        (v32/*: any*/),
                        (v89/*: any*/)
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "pageRestrictionsContextAncestors"
                  }
                ]
              },
              {
                "condition": "includeClassification",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "BylineClassification_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "bylineClassificationFragment"
                  },
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "useContentClassification_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "contentClassificationFragment"
                  },
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        (v32/*: any*/),
                        (v90/*: any*/)
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "contentClassification"
                  }
                ]
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "PageContentRenderer_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "pageContentRendererFragment"
              },
              {
                "condition": "includeAgentTrustReceiptData",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      (v91/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": (v53/*: any*/)
                      }
                    ]
                  },
                  (v92/*: any*/)
                ]
              },
              {
                "condition": "includeRendererAssetsMedia",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "ViewPageExtensionsAndRendererAssetsContentFragment_mediaContent"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "rendererAssetsMedia"
                  }
                ]
              },
              {
                "condition": "isSSR",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "ViewPageExtensionsAndRendererAssetsContentFragment_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "rendererAssetsMacroOutput"
                  }
                ]
              },
              (v93/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v94/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          (v32/*: any*/),
          {
            "concreteType": "Theme",
            "kind": "LinkedField",
            "name": "theme",
            "plural": false,
            "selections": [
              (v95/*: any*/),
              (v38/*: any*/)
            ]
          },
          {
            "concreteType": "LookAndFeel",
            "kind": "LinkedField",
            "name": "lookAndFeel",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentLookAndFeel",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v106/*: any*/),
                  (v109/*: any*/)
                ]
              }
            ]
          },
          (v110/*: any*/),
          (v111/*: any*/),
          (v113/*: any*/),
          {
            "condition": "includeContentHeader",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "ContentHeader_space"
                    }
                  ],
                  "type": "Space"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "contentHeaderFragment"
              }
            ]
          },
          {
            "kind": "FragmentSpread",
            "name": "ContentContainerTheme_space"
          },
          {
            "kind": "FragmentSpread",
            "name": "ContentTitle_space"
          },
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "PageContentRenderer_space"
                }
              ],
              "type": "Space"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "pageContentRendererFragment"
          }
        ]
      },
      (v114/*: any*/),
      (v116/*: any*/),
      {
        "condition": "includeAutohighlights",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": (v117/*: any*/),
                  "kind": "FragmentSpread",
                  "name": "preloadAutohighlightsQuery_query"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "autohighlightsQueryFragment"
          }
        ]
      },
      {
        "condition": "includeAnalyticsByline",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": (v118/*: any*/),
                  "kind": "FragmentSpread",
                  "name": "AnalyticsByLine_query"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "analyticsBylineFragment"
          }
        ]
      },
      (v119/*: any*/),
      {
        "condition": "includeBylineContributors",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v120/*: any*/),
            "concreteType": "ContentContributors",
            "kind": "LinkedField",
            "name": "contentContributors",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "ByLineContributors_contentContributors"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v26/*: any*/),
      (v29/*: any*/),
      (v23/*: any*/),
      (v20/*: any*/),
      (v19/*: any*/),
      (v18/*: any*/),
      (v25/*: any*/),
      (v28/*: any*/),
      (v24/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v11/*: any*/),
      (v3/*: any*/),
      (v10/*: any*/),
      (v8/*: any*/),
      (v17/*: any*/),
      (v22/*: any*/),
      (v21/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v16/*: any*/),
      (v15/*: any*/),
      (v7/*: any*/),
      (v27/*: any*/),
      (v9/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ContentUnifiedQuery",
    "selections": [
      {
        "args": (v31/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v43/*: any*/),
              (v68/*: any*/),
              (v37/*: any*/),
              (v40/*: any*/),
              (v42/*: any*/),
              (v45/*: any*/),
              (v46/*: any*/),
              (v48/*: any*/),
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v49/*: any*/),
                  (v50/*: any*/),
                  (v51/*: any*/),
                  (v123/*: any*/),
                  (v55/*: any*/),
                  (v56/*: any*/)
                ]
              },
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "draftVersion",
                "plural": false,
                "selections": [
                  (v49/*: any*/),
                  (v50/*: any*/),
                  (v51/*: any*/),
                  (v123/*: any*/),
                  (v55/*: any*/)
                ]
              },
              (v58/*: any*/),
              (v65/*: any*/),
              (v67/*: any*/),
              {
                "condition": "includeBylineContributors",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "emojiTitlePublished",
                    "args": (v82/*: any*/),
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": (v66/*: any*/),
                    "storageKey": "properties(key:\"emoji-title-published\")"
                  },
                  {
                    "alias": "editorProperty",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "key",
                        "value": "editor"
                      }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JsonContentProperty",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v32/*: any*/),
                          (v44/*: any*/),
                          (v41/*: any*/)
                        ]
                      }
                    ],
                    "storageKey": "properties(key:\"editor\")"
                  },
                  {
                    "concreteType": "ContentMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                      (v71/*: any*/),
                      (v124/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "homepageId"
                      }
                    ]
                  },
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      (v91/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": (v126/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "name": "ownedBy",
                        "plural": false,
                        "selections": (v126/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "name": "lastOwnedBy",
                        "plural": false,
                        "selections": (v126/*: any*/)
                      }
                    ]
                  },
                  {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": [
                          (v34/*: any*/),
                          (v84/*: any*/),
                          (v125/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v92/*: any*/),
                  (v69/*: any*/),
                  (v70/*: any*/),
                  (v73/*: any*/)
                ]
              },
              {
                "condition": "includeAutomationDiscoveries",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "ContentMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                      (v124/*: any*/)
                    ]
                  }
                ]
              },
              {
                "condition": "includeContentHeader",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "condition": "includeFabricEditorEligibility",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "concreteType": "ContentMetadata",
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                            "kind": "LinkedField",
                            "name": "frontend",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "fabricEditorEligibility"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "contentHash"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "includeContentHeaderAccess",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": (v127/*: any*/)
                  }
                ]
              },
              {
                "condition": "useNewContentTopper",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  (v69/*: any*/),
                  (v70/*: any*/),
                  (v72/*: any*/),
                  (v73/*: any*/)
                ]
              },
              {
                "condition": "includeRestrictions",
                "kind": "Condition",
                "passingValue": true,
                "selections": (v127/*: any*/)
              },
              {
                "condition": "preloadLabels",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "args": (v77/*: any*/),
                    "concreteType": "PaginatedLabelList",
                    "kind": "LinkedField",
                    "name": "labels",
                    "plural": false,
                    "selections": [
                      (v78/*: any*/),
                      {
                        "concreteType": "Label",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v121/*: any*/),
                          (v32/*: any*/),
                          (v79/*: any*/),
                          (v38/*: any*/),
                          (v80/*: any*/)
                        ]
                      }
                    ],
                    "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
                  }
                ]
              },
              {
                "condition": "includeReactions",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  (v81/*: any*/)
                ]
              },
              {
                "condition": "includeAudioContent",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  (v83/*: any*/),
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": (v128/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "name": "ownedBy",
                        "plural": false,
                        "selections": (v128/*: any*/)
                      }
                    ]
                  },
                  (v87/*: any*/),
                  (v88/*: any*/)
                ]
              },
              {
                "condition": "includeRestrictionAncestors",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  (v89/*: any*/)
                ]
              },
              {
                "condition": "includeClassification",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  (v90/*: any*/)
                ]
              },
              {
                "condition": "includeAgentTrustReceiptData",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      (v91/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": (v122/*: any*/)
                      }
                    ]
                  },
                  (v92/*: any*/)
                ]
              },
              {
                "condition": "includeRendererAssetsMedia",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "ContentBodyPerRepresentation",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "ContentBody",
                        "kind": "LinkedField",
                        "name": "atlas_doc_format",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "EmbeddedMediaToken",
                            "kind": "LinkedField",
                            "name": "mediaToken",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "token"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "isSSR",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "MapOfStringToFormattedBody",
                    "kind": "LinkedField",
                    "name": "macroRenderedOutput",
                    "plural": true,
                    "selections": [
                      (v44/*: any*/),
                      {
                        "concreteType": "FormattedBody",
                        "kind": "LinkedField",
                        "name": "value",
                        "plural": false,
                        "selections": [
                          (v41/*: any*/),
                          (v59/*: any*/),
                          {
                            "concreteType": "WebResourceDependencies",
                            "kind": "LinkedField",
                            "name": "webresource",
                            "plural": false,
                            "selections": (v64/*: any*/)
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v93/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v94/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          {
            "concreteType": "Theme",
            "kind": "LinkedField",
            "name": "theme",
            "plural": false,
            "selections": [
              (v38/*: any*/),
              (v95/*: any*/)
            ]
          },
          {
            "concreteType": "LookAndFeel",
            "kind": "LinkedField",
            "name": "lookAndFeel",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentLookAndFeel",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v106/*: any*/),
                  (v109/*: any*/),
                  {
                    "concreteType": "ContainerLookAndFeel",
                    "kind": "LinkedField",
                    "name": "header",
                    "plural": false,
                    "selections": [
                      (v96/*: any*/),
                      (v104/*: any*/),
                      (v105/*: any*/),
                      (v103/*: any*/),
                      (v97/*: any*/),
                      (v98/*: any*/),
                      (v102/*: any*/),
                      (v99/*: any*/),
                      (v101/*: any*/),
                      (v100/*: any*/),
                      (v108/*: any*/),
                      (v107/*: any*/)
                    ]
                  }
                ]
              },
              {
                "concreteType": "MapOfStringToString",
                "kind": "LinkedField",
                "name": "headings",
                "plural": true,
                "selections": (v47/*: any*/)
              }
            ]
          },
          (v32/*: any*/),
          (v110/*: any*/),
          (v111/*: any*/),
          (v113/*: any*/)
        ]
      },
      (v114/*: any*/),
      (v116/*: any*/),
      {
        "condition": "includeAutohighlights",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "KnowledgeDiscoveryQueryApi",
            "kind": "LinkedField",
            "name": "knowledgeDiscovery",
            "plural": false,
            "selections": [
              {
                "args": (v117/*: any*/),
                "kind": "LinkedField",
                "name": "keyPhrases",
                "plural": false,
                "selections": [
                  (v121/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "concreteType": "KnowledgeDiscoveryKeyPhrase",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "keyPhrase"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "category"
                          }
                        ]
                      }
                    ],
                    "type": "KnowledgeDiscoveryKeyPhraseConnection"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "message"
                      }
                    ],
                    "type": "QueryError"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "includeAnalyticsByline",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v118/*: any*/),
            "concreteType": "ContentAnalyticsViewers",
            "kind": "LinkedField",
            "name": "contentAnalyticsViewers",
            "plural": false,
            "selections": [
              (v78/*: any*/)
            ]
          },
          {
            "alias": "user",
            "args": [
              {
                "kind": "Literal",
                "name": "current",
                "value": true
              }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
              (v32/*: any*/),
              {
                "concreteType": "ConfluenceUser",
                "kind": "LinkedField",
                "name": "confluence",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "permissionType"
                  }
                ]
              }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
          }
        ]
      },
      (v119/*: any*/),
      {
        "condition": "includeBylineContributors",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v120/*: any*/),
            "concreteType": "ContentContributors",
            "kind": "LinkedField",
            "name": "contentContributors",
            "plural": false,
            "selections": [
              (v78/*: any*/),
              {
                "kind": "ScalarField",
                "name": "isCurrentUserContributor"
              },
              {
                "kind": "ScalarField",
                "name": "isOwnerContributor"
              },
              {
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": (v126/*: any*/)
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "5ca0895b358b50aa61a179f1d0119dec",
    "id": "78cee41998cc3d2b73d496dd6fcef832a7e943e7cf5bfe2324e0fa97fc4db942",
    "metadata": {},
    "name": "ContentUnifiedQuery",
    "operationKind": "query",
    "text": "query ContentUnifiedQuery($contentId:ID!,$spaceKey:String=null,$versionOverride:Int,$isSSR:Boolean=false,$includeRendererAssetsMedia:Boolean=false,$includeRendererAssetsDsp:Boolean=false,$includeRendererAssetsCustomChrome:Boolean=false,$rendererAssetsDspAction:DataSecurityPolicyAction=PAGE_EXPORT,$useNewContentTopper:Boolean=false,$preloadLabels:Boolean=false,$agentSessionsPropertyKey:String=\"\",$fetchAgentSessionsMarker:Boolean=false,$includeAgentTrustReceiptData:Boolean=false,$includeBylineContributors:Boolean=false,$bylineContributorsLimit:Int,$includeAutomationDiscoveries:Boolean=false,$includeAudioContent:Boolean=false,$includeReactions:Boolean=false,$includeRestrictions:Boolean=false,$includeRestrictionAncestors:Boolean=false,$includeClassification:Boolean=false,$includeContentHeader:Boolean=false,$includeContentHeaderAccess:Boolean=false,$includeFabricEditorEligibility:Boolean=false,$includeContentHeaderPublicLink:Boolean=false,$includeAnalyticsByline:Boolean=false,$useContentModeFragment:Boolean=false,$includeAutohighlights:Boolean=false,$autohighlightsEntityAri:String,$autohighlightsWorkspaceId:String)@allowHigherTimeout{mediaConfiguration@include(if:$includeRendererAssetsMedia){clientId,fileStoreUrl},dataSecurityPolicy@include(if:$includeRendererAssetsDsp){isActionEnabledForContent(action:$rendererAssetsDspAction,contentId:$contentId,contentStatus:CURRENT,contentVersion:1,spaceKey:$spaceKey){action,allowed}},...preloadAutohighlightsQuery_query_deyB3@include(if:$includeAutohighlights),...AnalyticsByLine_query_3SK5LQ@include(if:$includeAnalyticsByline),publicLinkPage(pageId:$contentId)@include(if:$includeContentHeaderPublicLink){pageId,pageStatus,accessType},content(id:$contentId,version:$versionOverride){nodes{...ViewPageCommentsPanelPermission_content,id,operations{operation,targetType},type,...PageStatusQueryRelaySpike_content,...PresenterModePortal_content,status,...ArchivedPageBannerV2Status_content,contentProperties{latest{contentMode},draft{contentMode}},...ContentModeFragmentProvider_content@include(if:$useContentModeFragment),contentState(isDraft:false){id,name,color,restrictionLevel},contentStateLastUpdated(format:USER_FRIENDLY){value},...ContentTitleWithByLine_content_2SjeOj@include(if:$includeBylineContributors)\n      ...useTitleContentPropertiesForPublishedPage_content@include(if:$includeBylineContributors)\n      ...CoverPictureQuery_content@include(if:$includeBylineContributors),...MeetingNotesAutomationDiscoveryFragment_content@include(if:$includeAutomationDiscoveries),title,space{id,name,key,alias},subType,smartFolderProperties:properties(keys:[\"smartFolderProperties\"]){nodes{key,value}},version{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when,confRev,when@include(if:$includeAgentTrustReceiptData)},draftVersion{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when},...ContentHeader_content_118EQH@include(if:$includeContentHeader),metadata{frontend{fabricEditorSupported,embedded,collabService,coverPictureWidth@include(if:$useNewContentTopper)},lastModifiedDate},id@include(if:$useNewContentTopper)\n      pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}}\n      pageTitleDraft:properties(key:\"page-title-property-draft\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}}\n      metadata@include(if:$useNewContentTopper){frontend{coverPictureWidth}}\n      coverPictureProperties:properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},id@include(if:$includeRestrictions)\n      hasInheritedRestrictions@include(if:$includeRestrictions)\n      hasRestrictions@include(if:$includeRestrictions)\n      hasViewRestrictions@include(if:$includeRestrictions)\n      title@include(if:$includeRestrictions),...ViewPageLabelsContentFragment_content@include(if:$preloadLabels)\n      labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING})@include(if:$preloadLabels){count,nodes{id,label,name,prefix}},id@include(if:$includeReactions)\n      contentReactionsSummary@include(if:$includeReactions){reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}\n      ...ReactionsContentFragment_content@include(if:$includeReactions),id@include(if:$includeAudioContent)\n      title@include(if:$includeAudioContent)\n      subType@include(if:$includeAudioContent)\n      emoji:properties(key:\"emoji-title-published\")@include(if:$includeAudioContent){nodes{id,value}}\n      history@include(if:$includeAudioContent){createdBy{__typename,displayName,profilePicture{path}},ownedBy{__typename,displayName,profilePicture{path}}}\n      links@include(if:$includeAudioContent){webui,base}\n      audioProperties:properties(keys:[\"emoji-title-published\",\"editor\"])@include(if:$includeAudioContent){nodes{value,key}}\n      ...AudioContentFragment_content@include(if:$includeAudioContent),id@include(if:$includeRestrictionAncestors)\n      ancestors@include(if:$includeRestrictionAncestors){id,title,hasRestrictions,links{webui}},...BylineClassification_content@include(if:$includeClassification)\n      ...useContentClassification_content@include(if:$includeClassification)\n      id@include(if:$includeClassification)\n      classificationLevelDetails@include(if:$includeClassification){classificationLevel{id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting},...PageContentRenderer_content,body{dynamic{representation,value,content{id,version{number}},webresource{superbatch{tags{js,css}},tags{js,css}}}},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"]){nodes{id,key,value,version{number}}},history@include(if:$includeAgentTrustReceiptData){createdDate,createdBy{__typename,displayName}}\n      contentProperties@include(if:$includeAgentTrustReceiptData){latest{generatedBy}},...ViewPageExtensionsAndRendererAssetsContentFragment_mediaContent@include(if:$includeRendererAssetsMedia),...ViewPageExtensionsAndRendererAssetsContentFragment_content@include(if:$isSSR),agentSessionsMarker:properties(key:$agentSessionsPropertyKey)@include(if:$fetchAgentSessionsMarker){nodes{id,key,value,version{number}}}}},contentContributors(id:$contentId,limit:$bylineContributorsLimit)@include(if:$includeBylineContributors){...ByLineContributors_contentContributors},space(key:$spaceKey){id@include(if:$includeRendererAssetsCustomChrome)\n    settings@include(if:$includeRendererAssetsCustomChrome){customHeaderAndFooter{header{html,js,css,spaUnfriendlyMacros{name}},footer{html,js,css,spaUnfriendlyMacros{name}}}},...ContentHeader_space@include(if:$includeContentHeader),...ContentContainerTheme_space,...ContentTitle_space,...PageContentRenderer_space,id,theme{themeKey,name},lookAndFeel{content{screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,layer{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,width,height},gutterTop,gutterRight,gutterBottom,gutterLeft},container{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius}}},settings{routeOverrideEnabled},currentUser{isAnonymouslyAuthorized}}}fragment AnalyticsByLine_query_3SK5LQ on Query{contentAnalyticsViewers(contentId:$contentId){count},user:confluence_atlassianUser(current:true){id,confluence{permissionType}}}fragment ArchivedPageBannerV2Status_content on Content{id,status}fragment AudioContentFragment_content on Content{id,title,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},history{createdBy{__typename,displayName,profilePicture{path}},ownedBy{__typename,displayName,profilePicture{path}}},links{webui,base},audioProperties:properties(keys:[\"emoji-title-published\",\"editor\"]){nodes{value,key}}}fragment ByLineContributors_contentContributors on ContentContributors{count,isCurrentUserContributor,isOwnerContributor,nodes{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}}fragment ByLine_content_2SjeOj on Content{...useReadTime_content,id,type,subType,history{createdDate,createdBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},ownedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},lastOwnedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},version{by{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},friendlyWhen,when,number,contentTypeModified},contentProperties{latest{generatedBy}},...RendererContentState_content,pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},editorProperty:properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{coverPictureWidth@include(if:$useNewContentTopper)}}}fragment BylineClassification_content on Content{id,title,type,status,operations{operation,targetType},space{id,name,key,alias},...useContentClassification_content}fragment ContentContainerTheme_space on Space{theme{name,themeKey},lookAndFeel{content{screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,layer{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,width,height},gutterTop,gutterRight,gutterBottom,gutterLeft},container{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius}}}}fragment ContentHeader_content_118EQH on Content{id,type,subType,title,status,metadata{lastModifiedDate,frontend{fabricEditorSupported}},...useFabricEligibilityMigrationQuery_content@include(if:$includeFabricEditorEligibility),...ContentTypesHeader_content,...EditContentButton_content,...useShareAndRestrictButtonData_content@include(if:$includeContentHeaderAccess)}fragment ContentHeader_space on Space{id,theme{themeKey}}fragment ContentModeFragmentProvider_content on Content{id,contentProperties{latest{contentMode},draft{contentMode}}}fragment ContentTitleWithByLine_content_2SjeOj on Content{...ContentTitle_content_2SjeOj,...ByLine_content_2SjeOj,...ArchivedPageBannerV2Status_content,...MeetingNotesAutomationDiscoveryFragment_content}fragment ContentTitle_content_2SjeOj on Content{id,type,title,appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},editorProperty:properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{fabricEditorSupported,coverPictureWidth@include(if:$useNewContentTopper)}},space{id,name,homepageId}}fragment ContentTitle_space on Space{id,theme{themeKey},lookAndFeel{headings{key,value},content{header{background,backgroundAttachment,backgroundBlendMode,backgroundClip,backgroundColor,backgroundImage,backgroundOrigin,backgroundPosition,backgroundRepeat,backgroundSize,borderRadius,padding}}}}fragment ContentTypesHeader_content on Content{id,title,operations{operation,targetType},space{id,name,key,alias},type,subType,status,smartFolderProperties:properties(keys:[\"smartFolderProperties\"]){nodes{key,value}},version{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when},draftVersion{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when}}fragment CoverPictureQuery_content on Content{id,coverPictureProperties:properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"]){nodes{id,key,value,version{number}}}}fragment EditContentButton_content on Content{id,type,operations{operation,targetType},metadata{frontend{fabricEditorSupported,embedded,collabService}},subType,space{id,key}}fragment MeetingNotesAutomationDiscoveryFragment_content on Content{id,title,body{dynamic{value}},metadata{sourceTemplateEntityId}}fragment PageContentRenderer_content on Content{id,title,type,status,version{confRev,number},metadata{lastModifiedDate},body{dynamic{representation,value,content{id,version{number}},webresource{superbatch{tags{js,css}},tags{js,css}}}},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"]){nodes{id,key,value,version{number}}}}fragment PageContentRenderer_space on Space{id,theme{themeKey}}fragment PageStatusQueryRelaySpike_content on Content{status}fragment PresenterModePortal_content on Content{title,properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"]){nodes{id,key,value,version{number}}}}fragment ReactionsContentFragment_content on Content{id,contentReactionsSummary{reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}}fragment RendererContentState_content on Content{id,contentState(isDraft:false){id,name,color,restrictionLevel},contentStateLastUpdated(format:USER_FRIENDLY){value}}fragment ViewPageCommentsPanelPermission_content on Content{id,operations{operation,targetType}}fragment ViewPageExtensionsAndRendererAssetsContentFragment_content on Content{macroRenderedOutput{key,value{value,representation,webresource{tags{js,css}}}}}fragment ViewPageExtensionsAndRendererAssetsContentFragment_mediaContent on Content{id,body{atlas_doc_format{mediaToken{token}}}}fragment ViewPageLabelsContentFragment_content on Content{id,type,status,operations{operation,targetType},space{id},labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING}){count,nodes{__typename,id,label,name,prefix}}}fragment preloadAutohighlightsQuery_query_deyB3 on Query{knowledgeDiscovery{keyPhrases(entityAri:$autohighlightsEntityAri,workspaceId:$autohighlightsWorkspaceId)@optIn(to:\"KnowledgeDiscovery Get Key Phrases\"){__typename,...on KnowledgeDiscoveryKeyPhraseConnection{nodes{keyPhrase,category}},...on QueryError{message}}}}fragment useContentClassification_content on Content{id,classificationLevelDetails{classificationLevel{id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting}}fragment useFabricEligibilityMigrationQuery_content on Content{id,metadata{frontend{fabricEditorEligibility,contentHash}}}fragment useReadTime_content on Content{id,type,body{dynamic{value,representation}},operations{operation,targetType}}fragment useShareAndRestrictButtonData_content on Content{id,hasInheritedRestrictions,hasRestrictions,hasViewRestrictions,title}fragment useTitleContentPropertiesForPublishedPage_content on Content{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}"
  }
};
})();

(node as any).hash = "a42375d39fb9722b01bc99cef3fd3229";

export default node;
